// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"db926324","139":"963ac455","544":"b2eb6127","574":"3bc0ab45","618":"d7867d82","671":"f318ee0e","688":"1a72dc5d"}[chunkId] + ".chunk.js";
};